export default {
  path: '/gift-cards',
  name: 'gift-cards',   
  component: () => import('@/views/giftCards/GiftCards.vue'),
  meta: {
    requiresAuth: true
  }
}
